<template>
      <el-col style="align-content: center;" :span="24" class="m-l-10">
            <el-radio-group
              v-model="mapTheme"
              text-color="#ffff"
              fill="#234B49"
              :class="$vuetify.display.width < 750 ? 'width-100-p' : ''"
            >
              <el-radio-button
                class="start-period all-group-by text-center"
                label="light"
                :class="$vuetify.display.width < 750 ? 'width-50-p' : ''"
              >
                <span>Light</span>
              </el-radio-button>
              <el-radio-button
                class="site-group-by text-center end-period"
                label="dark"
                :class="$vuetify.display.width < 750 ? 'width-50-p' : ''"
              >
                <span>Dark</span>
              </el-radio-button>
            </el-radio-group>
    </el-col>
    <el-col
      :span="$vuetify.display.width >= 1500 ? 24 : 24"
      class="width-100-p justify-content-end"
    >

      <div class="row m-0 px-0 bg-me-primary rounded-4">

        <el-col
          :span="24"
          class="mt-3 px-0"
          v-loading="loading"
          :element-loading-spinner="svg"
          element-loading-svg-view-box="-10, -10, 50, 50"
          element-loading-background="rgba(122, 122, 122, 0.8)"
        >
          <div
            :id="mapTheme == `light` ? `map` : `map-dark`"
            style="z-index: 1"
            :style="[
                  $vuetify.display.width >= 1500
                    ? { height: 635 + 'px' }
                    : $vuetify.display.width >= 500
                    ? { height: 600 + 'px' }
                    : { height: 340 + 'px' },
                ]"
          ></div>
  
          <div ref="popupContainer"></div>
        </el-col>
      </div>
    </el-col>
  </template>
  
  <script>
  import UserService from "../../../services/user.service";
  import L from "leaflet";
  import "leaflet/dist/leaflet.css";
  import "leaflet.markercluster/dist/MarkerCluster.css";
  import "leaflet.markercluster/dist/MarkerCluster.Default.css";
  import "leaflet.markercluster";
  import PopupContent from "./showPopup";
  import { createApp } from "vue";
  import ElementPlus from "element-plus";

  
  export default {
    props: {
      chargerDistributionProp: {
        type: Array,
        default: null,
      },
      loadingProp: {
        type: Boolean,
        default: false,
      },
      stateProp: {
        type: String,
        default: null,
      },
      filterProp: {
        type: Object,
        default: null,
      },
      mapDataProp: {
        type: Object,
        default: null,
      },
   
    },
    components: {
      // eslint-disable-next-line vue/no-unused-components
      PopupContent,
    },
    watch: {
   
      filterProp: {
        handler: function (newVal) {
          this.customer_id = newVal.customer_id;
          this.state = newVal.state == "All" ? "" : newVal.state;
          // console.log(newVal);
          this.fetchAllChargingSite();
        },
        deep: true,
      },
      mapDataProp: {
        handler: function (newVal) {
            this.setMapData(newVal);
        },
        deep: true,
      },
    
    },
    data() {
      return {
        mapTheme: "light",
  
        loading: false,
        state: null,
        map: null,
        markerClusterGroup: null,
        mapOption: {
          url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          attribution:
            '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          zoom: 8,
          center: [-37.8136, 144.9631],
        },
        mapOptions: {
          scrollWheelZoom: false,
        },
        SiteDataList: [],
        popup: null,
        popupData: {
          site_name: "",
          state: "",
          chargers_count: 0,
          chargers_capacity_sum: 0,
        },
        customer_id: null,
        circle: null,   // Circle layer
        // mapHeight: 400,
      };
    },
    mounted() {
      // this.fetchAllChargingSite();
      // this.initMap();
    },
    methods: {
        setMapData(data){
            this.SiteDataList = data.site_list;
            this.mapOption.center = [
                    data.center_lat ? data.center_lat : 0,
                    data.center_lng > 0 ? data.center_lng : 0,
                ];
            
            this.initMap();
            this.addCircle(data.center_lat ? data.center_lat : 0, data.center_lng ? data.center_lng : 0, data.radius ? data.radius : 0, data.unit ? data.unit : 'kms'); 
        },
        addCircle(lat, lng, radius, unit) {
                if (this.circle) {
                    this.map.removeLayer(this.circle);  
                }
                if (unit == 'miles') {
                    radius = radius * 1.60934 * 1000; // Convert miles to kilometers
                } else {
                    radius = radius * 1000; // Convert kilometers to meters
                }

                // console.log("add circle", lat, lng, radius, unit);
                
                this.circle = L.circle([lat, lng], {
                    color: 'blue',
                    fillColor: '#30f',
                    fillOpacity: 0.1,
                    radius: radius, // Convert km to meters
                }).addTo(this.map);

                this.circle.bindPopup(`Center at (${lat}, ${lng}) with radius ${radius / 1000} ${unit} `);
            },
        initMap() {
            if (this.map) {
            this.map.remove();
            }
            this.map = L.map(this.mapTheme == 'light' ? "map" : "map-dark", {
            zoomControl: true,
            zoom: 1,
            zoomAnimation: false,
            fadeAnimation: true,
            markerZoomAnimation: true,
            }).setView(this.mapOption.center, this.mapOption.zoom);
            L.tileLayer(this.mapOption.url, {
            attribution: this.mapOption.attribution,
            }).addTo(this.map);
            this.markerClusterGroup = L.markerClusterGroup();
            this.addMarkers();
            this.map.addLayer(this.markerClusterGroup);
            
        },

        addMarkers() {
            this.SiteDataList.forEach((item) => {
            if (item.lat == null) item.lat = 0;
            if (item.lng == null) item.lng = 0;
    
            L.marker([item.lat, item.lng],{icon: this.getCustomIcon(item.abatement_tco2)})
                .on("click", (e) => this.showPopup(e, item))
                .addTo(this.markerClusterGroup);
            });
        },

        getCustomIcon(value) {
          const color = this.getColorFromValue(value);
          return L.icon({
            iconUrl: this.getIconUrl(color),
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowUrl:
              "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
            shadowSize: [41, 41],
            shadowAnchor: [12, 41],
          });
        },
        getIconUrl(color) {
          const markerSvg = 
          `<svg width="31" height="43" viewBox="0 0 31 43" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2200_5329)">
          <path d="M15.4999 8.44043C11.5599 8.44043 8.35986 11.6804 8.35986 15.6404C8.35986 19.6104 11.5599 22.8404 15.4999 22.8404C19.4399 22.8404 22.6399 19.6004 22.6399 15.6404C22.6399 11.6804 19.4399 8.44043 15.4999 8.44043Z" fill="white"/>
          <path d="M15.5 0.5C23.77 0.5 30.5 7.29 30.5 15.65C30.5 18.15 29.88 20.63 28.72 22.81L15.5 42.12L2.28 22.81C1.11 20.62 0.5 18.14 0.5 15.64C0.5 7.29 7.23 0.5 15.5 0.5ZM15.5 8.44C11.56 8.44 8.36 11.68 8.36 15.64C8.36 19.61 11.56 22.84 15.5 22.84C19.44 22.84 22.64 19.6 22.64 15.64C22.64 11.68 19.44 8.44 15.5 8.44Z" fill="${color}" stroke="white"/>
          </g>
          <defs>
          <clipPath id="clip0_2200_5329">
          <rect width="31" height="43" fill="white"/>
          </clipPath>
          </defs>
          </svg>`;
          return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
            markerSvg
          )}`;
        },
        getColorFromValue(value) {
          let r, g, b;

          if (value < 0) {
            // For negative values, set to light green
            r = 3;
            g = 125;
            b = 164;
          } else if (value <= 1) {
            // Level 1: Light green
            r = 79;
            g = 153;
            b = 220;
          } else if (value <= 2) {
            // Level 2: Slightly darker green
            r = 112;
            g = 187;
            b = 211;
          } else if (value <= 3) {
            // Level 3: Medium green
            r = 218;
            g = 255;
            b = 123;
          } else if (value <= 4) {
            // Level 4: Darker green
            r = 244;
            g = 215;
            b = 97;
          } else if (value <= 5) {
            // Level 5: Deep green
            r = 229;
            g = 160;
            b = 57;
          } else if (value <= 6) {
            // Level 6: Very deep green
            r = 231;
            g = 59;
            b = 48;
          } else if (value <= 7) {
            // Level 7: Almost dark green
            r = 231;
            g = 59;
            b = 48;
          } else if (value <= 8) {
            // Level 8: Dark green
            r = 120;
            g = 190;
            b = 32;
          } else if (value <= 9) {
            // Level 9: Very dark green
            r = 120;
            g = 190;
            b = 32;
          } else if (value <= 10) {
            // Level 10: Deepest green
            r = 20;
            g = 96;
            b = 20;
          } else {
            // For values > 10, set to the deepest green
            r = 20;
            g = 96;
            b = 20;
          }

          return `rgb(${r},${g},${b})`;
        },
  
        showPopup(e, marker) {
            if (this.popup) {
            this.popup.remove();
            }

            this.popupData = marker;
            // console.log("popupData", this.popupData);
            
            const popupContainer = document.createElement("div");
            const appInstance = createApp(PopupContent, {
            popupData: this.popupData,
            }).use(ElementPlus);
            appInstance.mount(popupContainer);
            this.map.flyTo(e.latlng, this.map.getZoom());
            this.popup = L.popup()
            .setLatLng(e.latlng)
            .setContent(popupContainer)
            .openOn(this.map);
        },
  
      fetchAllChargingSite() {
        let filter = {
          state: this.state,
        };
        if (this.customer_id != null) {
          filter = {
            customer_id: this.customer_id,
            state: this.state,
          };
        }
        this.loading = true;
        UserService.ChargersDistributions(filter)
          .then(
            (response) => {
              this.SiteDataList = response.data.data.charger_distribution;
              this.mapOption.center = [
                this.SiteDataList.length > 0 ? this.SiteDataList[0].lat : 0,
                this.SiteDataList.length > 0 ? this.SiteDataList[0].lng : 0,
              ];
              this.initMap();
            },
            (error) => {
              this.loading = false;
              console.log(error);
              if (error.response.status == 401) {
                this.$router.push({
                  path: "/",
                });
              }
            }
          )
          .catch((error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          })
          .finally(() => (this.loading = false));
      },
    },
  };
  </script>
  
  
  